import { z } from 'zod';

// Predefined folder colors (consistent with Fluent UI / Teams)
export const FOLDER_COLORS = [
  '#0078D4', // Blue (default)
  '#107C10', // Green
  '#FFB900', // Yellow
  '#D83B01', // Orange
  '#E74856', // Red
  '#881798', // Purple
  '#00B7C3', // Teal
  '#8764B8', // Violet
  '#038387', // Dark Teal
  '#767676', // Gray
] as const;

export type FolderColor = (typeof FOLDER_COLORS)[number];

// Folder schema
export const FolderSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string().optional(),
  createdAt: z.string().or(z.date()),
  updatedAt: z.string().or(z.date()),
  recordingsCount: z.number().optional(),
});

export type Folder = z.infer<typeof FolderSchema>;

// Create folder request
export const CreateFolderSchema = z.object({
  name: z.string().min(1).max(100),
  color: z.string().optional(),
});

export type CreateFolder = z.infer<typeof CreateFolderSchema>;

// Rename/Update folder request
export const RenameFolderSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  color: z.string().optional(),
});

export type RenameFolder = z.infer<typeof RenameFolderSchema>;

// Folders list response
export const FoldersListSchema = z.array(FolderSchema);

export type FoldersList = z.infer<typeof FoldersListSchema>;

// Folders list response with unclassified count
export const FoldersListResponseSchema = z.object({
  folders: FoldersListSchema,
  unclassifiedCount: z.number(),
});

export type FoldersListResponse = z.infer<typeof FoldersListResponseSchema>;

// User recording folder assignment
export const UserRecordingFolderSchema = z.object({
  userId: z.string(),
  recordingId: z.string(),
  folderId: z.string(),
  assignedAt: z.string().or(z.date()),
});

export type UserRecordingFolder = z.infer<typeof UserRecordingFolderSchema>;
